<nav class="nav nav-secondary mixed-loyalty-nav shadow mt-0">
  <a
    class="nav-item"
    [routerLink]="['/games/' + routeLink]"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'game.nav.' + routeLink + '.screenreader' | translate }}"
  >
    <label>{{ routeLink + '.nav.featured' | translate : { fgbdefault: 'Live & Upcoming' } }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/games/' + routeLink + '/leaderboard']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'game.nav.' + routeLink + '.leaderboard.screenreader' | translate }}"
  >
    <label>{{ 'games.nav.' + routeLink + '.leaderboard' | translate : { fgbdefault: 'Leaderboard' } }}</label>
  </a>
</nav>
